/**
 * Predict the number of items that will be fetched via pagination
 * E.g. if you have 10 items, want 10 more, but only 15 are available, return 5.
 * @param {number} loaded currently loaded items count
 * @param {number} fetching number of new items being fetched
 * @param {number} available total available items for load count
 */
export const getLoadCount = (loaded, fetching, available) => {
  if (loaded >= available) {
    return 0;
  }

  if (loaded + fetching <= available) {
    return fetching;
  }

  return available - loaded;
};
